
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Controlador as ControladorPrincipal } from '../../../controlador';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public get Pedido() { return this.ControladorBarras.PedidoSeleccionado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            if ( !this.Pedido )
            {
                return;
            }

            this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 500;
            this.Iniciar();
        }


        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        public Envio: Envio = new Envio();
        public HayCambios: boolean = false;


        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );
            this.Envio = await Envio.create( this.Pedido.Envio.Id );

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Envio.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Pedido.Envio = this.Envio;
                this.Cerrar();
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        async Cerrar()
        {
            this.SubModo = 'pedidos';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
